exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sachinmacbook/Sites/ngfront/src/app/new-service/new-service.component.css
// module id = ../../../../../src/app/new-service/new-service.component.css
// module chunks = main